import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AppState } from '../../core';

@Component({
  selector: 'merged-excel-confirmation-modal',
  templateUrl: './merged-excel-confirmation-modal.component.html'
})
export class MergedExcelConfirmationModalComponent {
  // Set via BsModalService initialState
  sharedCriteria: { stage: string; buildingid: string; participant: string; routeid?: string };
  groupingFields: string[];
  recordCount: number;
  onConfirm: (startDate: string, endDate: string) => Promise<void>;
  startDate = '';
  endDate = '';

  isProcessing = false;

  constructor(public bsModalRef: BsModalRef, public appState: AppState) {}

  async onContinue() {
    this.isProcessing = true;
    try {
      await this.onConfirm(this.startDate, this.endDate);
      this.bsModalRef.hide();
    } catch (error) {
      this.appState.notifyError(error, this, 3);
    } finally {
      this.isProcessing = false;
    }
  }

  onCancel() {
    this.bsModalRef.hide();
  }
}
